import { isNil } from 'lodash'
import { DateTime } from 'luxon'

export const getDaysFromServiceLength = ({
  containerOfferServiceLengthValue,
}: {
  containerOfferServiceLengthValue?: string | number
}) => {
  if (isNil(containerOfferServiceLengthValue)) {
    return 0
  } else if (typeof containerOfferServiceLengthValue === 'string') {
    if (containerOfferServiceLengthValue.endsWith('H')) {
      return 0
    } else if (containerOfferServiceLengthValue.endsWith('Y')) {
      const yearNumber = parseInt(
        containerOfferServiceLengthValue.slice(
          0,
          containerOfferServiceLengthValue.length - 1
        )
      )
      const futureDate = DateTime.now().plus({ years: yearNumber })
      return Math.ceil(futureDate.diff(DateTime.now(), 'days').days)
    } else if (containerOfferServiceLengthValue.endsWith('M')) {
      const monthNumber = parseInt(
        containerOfferServiceLengthValue.slice(
          0,
          containerOfferServiceLengthValue.length - 1
        )
      )
      if (isNaN(monthNumber)) return 0
      const futureDate = DateTime.now().plus({ months: monthNumber })
      return Math.ceil(futureDate.diff(DateTime.now(), 'days').days)
    } else if (containerOfferServiceLengthValue.endsWith('D')) {
      const dayNumber = parseInt(
        containerOfferServiceLengthValue.slice(
          0,
          containerOfferServiceLengthValue.length - 1
        )
      )
      return isNaN(dayNumber) ? 0 : dayNumber
    } else {
      return 0
    }
  } else {
    return containerOfferServiceLengthValue
  }
}
